export enum AdditionalReferenceItem {
	ADDITIONAL_REFERENCE_1 = 'additionalReference1',
	ADDITIONAL_REFERENCE_2 = 'additionalReference2',
}